import { Component, OnInit, Optional, QueryList, ViewChild, ViewChildren } from '@angular/core';
import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
//Services
import { UtilityService } from '../../../core/services/utility.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { HiringService } from './../../../pages/hiring/services/hiring.service';

import { AddressConfirmationModalComponent } from 'src/app/modals/employee/personal-info/address-confirmation-modal/address-confirmation-modal.component';
import { SignaturePad } from '@viablelogic/ngx-signature-pad';
import { Signature } from '@syncfusion/ej2-angular-pdfviewer';

@Component({
  selector: 'app-filli9',
  templateUrl: './filli9.component.html',
  styleUrls: ['./filli9.component.css'],
})
export class Filli9Component implements OnInit {
  @ViewChild('I9Form', { static: true }) I9Form: NgForm;
  @ViewChild('signEmployee', { static: false }) signEmployee;
  @ViewChild('signPreorTran', { static: false }) signPreorTran;
  @ViewChildren('signPreorTran2023') signPreorTran2023: QueryList<SignaturePad>;
  portalSettings: any;
  format: string;
  formData: { [key: string]: any } = {};
  sign: { [key: string]: any } = {};
  date: { [key: string]: any } = {};
  datePickerOptions: {
    dateInputFormat: string;
    containerClass: string;
    showTodayButton: boolean;
    showClearButton: boolean;
    clearPosition: string;
    showWeekNumbers: boolean;
  };
  mobileMode = false;
  isAddressValidationEnabled = false;
  enableCheckboxSign;
  boolean = false;
  latitude: any;
  longitude: any;
  alreadySubmitted = false;
  Q4NA = false;
  validateCheck = false;
  stateList: any[] = [];
  alert: any;
  panelWidth: number;
  new2023: any;
  signaturePadOptions: Object = {
    canvasWidth: 470,
    canvasHeight: 150,
  };
  preparerInvalid2023 = false;
  isReturnFromEmployerI9Form = false;
  employerCommentI9Form: string;
  constructor(
    portalSettingsService: PortalSettingsService,
    private hiringService: HiringService,
    private utilityService: UtilityService,
    @Optional() public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private router: Router
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.format = utilityService.getDateFormat().toUpperCase();
  }

  ngOnInit(): void {
    this.new2023 = false;
    this.mobileMode = this.utilityService.isMobileMode();
    this.datePickerOptions = {
      dateInputFormat: this.format,
      containerClass: 'theme-blue',
      showTodayButton: true,
      showClearButton: true,
      clearPosition: 'left',
      showWeekNumbers: false,
    };
    this.isAddressValidationEnabled = this.portalSettings.IsAddressValidated.ConfigValue == '1';
    this.enableCheckboxSign = this.portalSettings.EnableCheckboxSign.ConfigValue == '1' ? true : false;
    this.sign['signPreorTran'] = this.signPreorTran;
    this.sign.signPreorTranNotEmpty = false;
    this.sign['signEmployee'] = this.signEmployee;
    this.sign.signEmployeeNotEmpty = false;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
      });
    }

    this.getInfoByOnboardID();
    this.getDependentLookupByColumnName();
    this.getI9ForOnboardee();
  }

  checkSSN() {
    if (this.formData.S1SSNtemp != null) {
      if (this.formData.S1SSNtemp?.length != 11) this.formData.S1SSNtemp = null;
    }
  }

  getInfoByOnboardID() {
    this.hiringService.getInfoByOnboardID().then((response: any) => {
      if (response != null) {
        this.isReturnFromEmployerI9Form = response.IsReturnFromEmployerI9Form;
        this.employerCommentI9Form = response.EmployerCommentI9Form;
        if (response?.DateSubmitted != null) {
          this.alreadySubmitted = true;
          if (
            new Date(
              parseInt(moment(response.DateSubmitted).utc().format('YYYY')),
              parseInt(moment(response.DateSubmitted).utc().format('MM')) - 1,
              parseInt(moment(response.DateSubmitted).utc().format('DD')),
              0,
              0,
              0,
              0
            ) >= new Date('2023/10/4')
          )
            this.new2023 = true;
        } else {
          if (new Date() >= new Date('2023/10/4')) this.new2023 = true;
          this.alreadySubmitted = false;
        }
      }
      if (this.new2023) {
        this.formData.PreparerList = [];
      }
    });
  }

  getDependentLookupByColumnName() {
    this.hiringService.getDependentLookupByColumnName('State').then((response: any) => {
      if (response != null) {
        this.stateList = response;
      }
    });
  }

  getI9ForOnboardee(): void {
    this.hiringService.getI9ForOnboardee().then((response: any) => {
      if (response?.length > 0) {
        for (const [key, val] of Object.entries(response[0])) {
          if (key == 'IsPreparerUsed') {
            if (val != null) {
              this.formData.IsPreparerUsedYN = val ? 'Y' : 'N';
            }
          } else if (key == 'S1BirthDate') {
            if (val != null) {
              this.date.S1BirthDate = new Date(moment(val).utc().format('MM/DD/YYYY'));
            }
          } else if (key == 'S1AlienExpiration') {
            if (val != null) {
              this.date.S1AlienExpiration = new Date(moment(val).utc().format('MM/DD/YYYY'));
            }
          } else if (key == 'S1SignatureDate') {
            if (val != null) {
              this.date.S1SignatureDate = new Date(moment(val).utc().format('MM/DD/YYYY'));
            } else {
              this.date.S1SignatureDate = new Date(moment().format('MM/DD/YYYY'));
            }
          } else if (key == 'PreparerSignatureDate') {
            if (val != null) {
              this.date.PreparerSignatureDate = new Date(moment(val).utc().format('MM/DD/YYYY'));
            } else {
              if (response[0].IsPreparerUsed) {
                this.date.PreparerSignatureDate = new Date(moment().format('MM/DD/YYYY'));
              }
            }
          } else if (key == 'S1SSN') {
            if (val != null) {
              this.formData.S1SSNtemp = val;
            }
          } else if ((key == 'PreparerSignatureBinary' || key == 'S1SignatureBinary') && this.alreadySubmitted) {
            if (key == 'PreparerSignatureBinary' && this.sign.signPreorTransubmitSignImg == null)
              this.sign.signPreorTransubmitSignImg = 'data:image/png;base64,' + this.base64ArrayBuffer(val);
            if (key == 'S1SignatureBinary' && this.sign.signEmployeesubmitSignImg == null)
              this.sign.signEmployeesubmitSignImg = 'data:image/png;base64,' + this.base64ArrayBuffer(val);
          } else if (key == 'S1Address') {
            if (val != null) this.formData.S1Address = new String(val).substring(0, 40);
          } else if (key != 'PreparerSignatureBinary' && key != 'S1SignatureBinary') {
            this.formData[key] = val;
          }
        }
        if (this.formData.S1CitizenStatus == 4 && this.date.S1AlienExpiration == null) this.Q4NA = true;
      } else {
        this.date.S1SignatureDate = new Date(moment().format('MM/DD/YYYY'));
      }

      if (this.formData.IsPreparerUsedYN == 'Y' && this.new2023) {
        this.hiringService.onboardI9GetSupA(null).then((response: any) => {
          response.forEach((val: any) => {
            this.formData.PreparerList.push({
              PreparerSignatureDate: new Date(moment(val.Date).utc().format('MM/DD/YYYY')),
              PreparerLastName: val.LastName,
              PreparerFirstName: val.FirstName,
              PreparerMiddleInitial: val.MiddleInitial,
              PreparerAddress: val.Address,
              PreparerCity: val.City,
              PreparerState: val.State,
              PreparerZip: val.ZipCode,
              signPreorTranshowClickMsg: false,
              signPreorTranRedBorder: false,
              signPreorTransubmitSignImg: null,
              signPreorTranhideClick: false,
              signPreorTranNotEmpty: false,
              signPreorTranrawImgData: null,
              signPreorTrantypeSign: false,
              seq: val.Seq,
            });
          });
        });
      }
    });
  }

  checkAddress(parmName: any) {
    var regex =
      /^ *((#\d+)|((box|bin)[-. \/\\]?\d+)|(.*p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(number|num|#)? *\d+|(num|number|#) *\d+)/i;
    var match = regex.exec(this.formData[parmName]);

    if (match != null) {
      this.formData[parmName + 'Invalid'] = true;
    } else {
      this.formData[parmName + 'Invalid'] = false;
    }
  }

  submit(isAddressInvalid: any) {
    isAddressInvalid = typeof isAddressInvalid == 'undefined' ? null : isAddressInvalid == true;
    this.formData.isReturnFromEmployerI9Form = false;
    this.hiringService.insertUpdateI9(this.formData).then((response: any) => {
      this.validateCheck = false;
      if (response.success) {
        if (this.new2023 && this.formData.IsPreparerUsedYN == 'Y') {
          var objData = [];
          this.formData.PreparerList.forEach((val, _) => {
            objData.push({
              Seq: val.seq,
              PreparerSignature: val.signPreorTranrawImgData.replace(/^data:image\/(png|jpg);base64,/, ''),
              LastName: val.PreparerLastName,
              FirstName: val.PreparerFirstName,
              MiddleInitial: val.PreparerMiddleInitial != null ? val.PreparerMiddleInitial : '',
              Address: val.PreparerAddress,
              City: val.PreparerCity,
              State: val.PreparerState,
              ZipCode: val.PreparerZip,
              DateStr: moment(val.preparerSignatureDateStr).utc().format('MM/DD/YYYY'),
            });
          });
          this.hiringService.onboardI9SupAInsertUpdate(objData).then((response: any) => {
            if (response.success) this.router.navigate(['/careers/tasks']);
          });
        } else {
          this.router.navigate(['/careers/tasks']);
        }
      } else {
      }
    });
  }

  saveI9() {
    this.validateCheck = true;
    this.checkSigned();
    this.checkSSN();

    if (
      !this.I9Form.form.invalid &&
      !this.formData.S1AddressInvalid &&
      !this.formData.PreparerAddressInvalid &&
      this.formData.S1CitizenStatus != null &&
      this.formData.S1SSNtemp != null
    ) {
      this.alert = null;
      if (
        (this.sign.signEmployeeNotEmpty && this.formData.IsPreparerUsedYN == 'N') ||
        (this.sign.signEmployeeNotEmpty && this.formData.IsPreparerUsedYN == 'Y' && this.sign.signPreorTranNotEmpty && !this.new2023) ||
        (this.sign.signEmployeeNotEmpty && this.formData.IsPreparerUsedYN == 'Y' && !this.preparerInvalid2023 && this.new2023)
      ) {
        if (this.formData.S1SSNtemp != null) {
          this.formData.S1SSN = this.formData.S1SSNtemp.split('-').join('');
        }
        if (this.date.S1BirthDate != null) {
          this.formData.S1BirthDateStr = moment(this.date.S1BirthDate).utc().format('MM/DD/YYYY');
        }
        if (this.date.S1AlienExpiration != null) {
          this.formData.S1AlienExpirationStr = moment(this.date.S1AlienExpiration).utc().format('MM/DD/YYYY');
        }
        if (this.date.S1SignatureDate != null) {
          this.formData.S1SignatureDateStr = moment(this.date.S1SignatureDate).utc().format('MM/DD/YYYY');
        }
        if (this.date.PreparerSignatureDate != null) {
          this.formData.PreparerSignatureDateStr = moment(this.date.PreparerSignatureDate).utc().format('MM/DD/YYYY');
        }
        if (this.sign.signEmployeetypeSign) {
          this.formData.S1SignatureBinary = this.sign.signEmployeerawImgData;
        } else {
          if (this.formData.S1SignatureBinary == null)
            this.formData.S1SignatureBinary = this.signEmployee.toDataURL().replace(/^data:image\/(png|jpg);base64,/, '');
        }
        if (this.formData.IsPreparerUsedYN == 'Y' && !this.new2023) {
          if (this.sign.signPreorTrantypeSign) {
            this.formData.PreparerSignatureBinary = this.sign.signPreorTranrawImgData;
          } else {
            if (this.formData.PreparerSignatureBinary == null)
              this.formData.PreparerSignatureBinary = this.signPreorTran.toDataURL().replace(/^data:image\/(png|jpg);base64,/, '');
          }
          this.formData.IsPreparerUsed = true;
        } else {
          this.formData.IsPreparerUsed = false;
        }
        if (this.longitude != null) this.formData.longitude = this.longitude;
        if (this.latitude != null) this.formData.latitude = this.latitude;
        Object.entries(this.formData).forEach(([key, val], index) => {
          if (val == '') this.formData[key] = null;
        });

        if (!this.isAddressValidationEnabled) {
          this.submit(true);
          return;
        }

        this.validateAddress();
        return;
      } else {
        window.scrollTo(0, 0);
        this.alert = 'Please fill out or correct all required fields.';
      }
    } else {
      window.scrollTo(0, 0);
      this.alert = 'Please fill out or correct all required fields.';
    }
  }

  validateAddress() {
    this.hiringService.validateAddress(this.formData.S1Address, this.formData.S1City, this.formData.S1State, this.formData.S1Zip).then(
      (response: any) => {
        if (response != null) {
          if (response.IsValid == false) {
            this.openAddressValidationModal(response.SuggestedAddressString, response.OriginalAddressString, response.SuggestedAddress);
          } else {
            this.submit(true);
          }
        } else {
          var address = this.formData.S1Address + ', ' + this.formData.S1City + ', ' + this.formData.S1State + ' ' + this.formData.S1Zip;
          this.openAddressValidationModal(null, address, null);
        }
      },
      error => {
        var address = this.formData.S1Address + ', ' + this.formData.S1City + ', ' + this.formData.S1State + ' ' + this.formData.S1Zip;
        this.openAddressValidationModal(null, address, null);
      }
    );
  }

  openAddressValidationModal(suggestedAddress: string, originalAddress: string, suggestedAddressComponents: any) {
    const modalRef = this.modalService.open(AddressConfirmationModalComponent, { size: 'sm', backdrop: 'static' });
    modalRef.componentInstance.suggestedAddress = suggestedAddress;
    modalRef.componentInstance.badAddress = originalAddress;

    modalRef.result.then(userChoice => {
      // User chose bad address
      if (userChoice == 0) {
        this.submit(true);
      }
      // User chose suggested address
      else if (userChoice == 1) {
        this.formData.S1Address = suggestedAddressComponents.Address;
        this.formData.S1City = suggestedAddressComponents.City;
        this.formData.S1State = suggestedAddressComponents.State;
        this.formData.S1Zip = suggestedAddressComponents.PostalCode;
        this.submit(false);
      }
      // User chose to cancel
      else {
        this.utilityService.closeModal();
      }
    });
  }

  statusChange() {
    if (this.formData.S1CitizenStatus == 1 || this.formData.S1CitizenStatus == 2) {
      this.formData.S1AlienUSCISNumberQ3 = null;
      this.date.S1AlienExpiration = null;
      this.formData.S1AlienUSCISNumberQ4 = null;
      this.formData.S1FormI94Admission = null;
      this.formData.S1ForeignPassportNumber = null;
      this.formData.S1IssuanceCountry = null;
      this.Q4NA = false;
    } else if (this.formData.S1CitizenStatus == 3) {
      this.formData.S1AlienUSCISNumberQ4 = null;
      this.formData.S1FormI94Admission = null;
      this.formData.S1ForeignPassportNumber = null;
      this.formData.S1IssuanceCountry = null;
      this.date.S1AlienExpiration = null;
      this.Q4NA = false;
    } else {
      this.formData.S1AlienUSCISNumberQ3 = null;
    }
  }

  preparerChange() {
    setTimeout(() => {
      if (this.formData.IsPreparerUsedYN == 'N') {
        this.date.PreparerSignatureDate = null;
        this.formData.PreparerLastName = null;
        this.formData.PreparerFirstName = null;
        this.formData.PreparerAddress = null;
        this.formData.PreparerCity = null;
        this.formData.PreparerState = null;
        this.formData.PreparerZip = null;
        if (this.new2023) {
          this.formData.PreparerList = [];
        }
      } else {
        if (this.new2023 && this.formData.PreparerList.length == 0) this.addPreparerRow();
        if (this.validateCheck) {
          if (this.signPreorTran?.isEmpty() == false) {
            this.sign.signPreorTranRedBorder = false;
          } else {
            this.sign.signPreorTranRedBorder = true;
          }
        }
        if (this.date.PreparerSignatureDate == null) {
          this.date.PreparerSignatureDate = new Date(moment().format('MM/DD/YYYY'));
        }
      }
    });
  }

  q4NAChange() {
    if (this.Q4NA) this.date.S1AlienExpiration = null;
  }

  cancelClicked() {
    this.activeModal.close('cancel');
  }

  getTypeSign(type: string, name: string) {
    this.sign[name + 'typeSign'] = true;
    this.hiringService
      .getTypeSign(type, name == 'signPreorTran' ? this.formData.PreparerFirstName + ' ' + this.formData.PreparerLastName : '')
      .then((response: any) => {
        if (response != null) {
          this.sign[name + 'rawImgData'] = this.base64ArrayBuffer(response);
          this.sign[name + 'submitSignImg'] = 'data:image/png;base64,' + this.base64ArrayBuffer(response);
          this.sign[name + 'NotEmpty'] = true;
          this.sign[name + 'hideClick'] = true;
        }
      });
    this.sign[name + 'showClickMsg'] = false;
  }

  clickSign(type: string, name: string) {
    if (name == 'signPreorTran') {
      if (this.signPreorTran?.isEmpty()) {
        this.getTypeSign(type, name);
      } else {
        this.sign[name + 'showClickMsg'] = true;
      }
    } else if (name == 'signEmployee') {
      if (this.signEmployee?.isEmpty()) {
        this.getTypeSign(type, name);
      } else {
        this.sign[name + 'showClickMsg'] = true;
      }
    }
  }

  checkSigned() {
    if (this.formData.IsPreparerUsedYN == 'Y') {
      this.checkPreparerSignature();
    } else {
      this.sign.signPreorTranNotEmpty = true;
    }
    if (this.signEmployee?.isEmpty()) {
      this.sign.signEmployeeRedBorder = true;
    } else {
      this.sign.signEmployeeNotEmpty = true;
      this.sign.signEmployeeRedBorder = false;
    }
  }

  checkPreparerSignature() {
    if (this.new2023) {
      this.signPreorTran2023?.forEach((signaturePad: SignaturePad, index: number) => {
        if (signaturePad?.isEmpty()) {
          this.preparerInvalid2023 = true;
          this.formData.PreparerList[index].signPreorTranNotEmpty = false;
          this.formData.PreparerList[index].signPreorTranRedBorder = true;
        } else {
          this.preparerInvalid2023 = false;
          this.formData.PreparerList[index].signPreorTranNotEmpty = true;
          this.formData.PreparerList[index].signPreorTranRedBorder = false;
          this.formData.PreparerList[index].signPreorTranrawImgData = signaturePad.toDataURL();
        }
      });
    } else {
      if (this.signPreorTran?.isEmpty()) {
        this.sign.signPreorTranNotEmpty = false;
        this.sign.signPreorTranRedBorder = true;
      } else {
        this.sign.signPreorTranNotEmpty = true;
        this.sign.signPreorTranRedBorder = false;
        this.sign.signPreorTranrawImgData = this.signPreorTran.toDataURL();
      }
    }
  }

  clear(name: string) {
    if (name == 'signPreorTran' && this.signPreorTran != null) {
      this.signPreorTran.clear();
    } else if (name == 'signEmployee' && this.signEmployee != null) {
      this.signEmployee.clear();
    }
    this.sign[name + 'NotEmpty'] = false;
    this.sign[name + 'rawImgData'] = null;
    this.sign[name + 'submitSignImg'] = null;
    this.sign[name + 'typeSign'] = false;
    this.sign[name + 'showClickMsg'] = false;
    this.sign[name + 'hideClick'] = false;
  }

  base64ArrayBuffer(arrayBuffer) {
    var base64 = '';
    var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

    var bytes = new Uint8Array(arrayBuffer);
    var byteLength = bytes.byteLength;
    var byteRemainder = byteLength % 3;
    var mainLength = byteLength - byteRemainder;

    var a, b, c, d;
    var chunk;

    // Main loop deals with bytes in chunks of 3
    for (var i = 0; i < mainLength; i = i + 3) {
      // Combine the three bytes into a single integer
      chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];

      // Use bitmasks to extract 6-bit segments from the triplet
      a = (chunk & 16515072) >> 18; // 16515072 = (2^6 - 1) << 18
      b = (chunk & 258048) >> 12; // 258048   = (2^6 - 1) << 12
      c = (chunk & 4032) >> 6; // 4032     = (2^6 - 1) << 6
      d = chunk & 63; // 63       = 2^6 - 1

      // Convert the raw binary segments to the appropriate ASCII encoding
      base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
    }

    // Deal with the remaining bytes and padding
    if (byteRemainder == 1) {
      chunk = bytes[mainLength];

      a = (chunk & 252) >> 2; // 252 = (2^6 - 1) << 2

      // Set the 4 least significant bits to zero
      b = (chunk & 3) << 4; // 3   = 2^2 - 1

      base64 += encodings[a] + encodings[b] + '==';
    } else if (byteRemainder == 2) {
      chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1];

      a = (chunk & 64512) >> 10; // 64512 = (2^6 - 1) << 10
      b = (chunk & 1008) >> 4; // 1008  = (2^6 - 1) << 4

      // Set the 2 least significant bits to zero
      c = (chunk & 15) << 2; // 15    = 2^4 - 1

      base64 += encodings[a] + encodings[b] + encodings[c] + '=';
    }

    return base64;
  }

  updateZip(data: string, field: any, index: any) {
    switch (field) {
      case 'S1Zip':
        this.formData.S1Zip = data;
        break;
      case 'PreparerZip':
        this.formData.PreparerZip = data;
        break;
      case 'PreparerZip2023':
        this.formData.PreparerList[index].PreparerZip = data;
        break;
    }
  }

  updateSSN(data: string) {
    this.formData.S1SSNtemp = data;
  }

  updatePhone(data: string) {
    this.formData.S1EmployeePhone = data;
  }

  public addPreparerRow() {
    this.formData.PreparerList.push({
      PreparerSignatureDate: null,
      PreparerLastName: null,
      PreparerFirstName: null,
      PreparerMiddleInitial: null,
      PreparerAddress: null,
      PreparerCity: null,
      PreparerState: null,
      PreparerZip: null,
      signPreorTranshowClickMsg: false,
      signPreorTranRedBorder: false,
      signPreorTransubmitSignImg: null,
      signPreorTranhideClick: false,
      signPreorTranNotEmpty: false,
      signPreorTranrawImgData: null,
      signPreorTrantypeSign: false,
      seq: -1,
    });
  }

  public deletePreparerRow(index: any) {
    if (this.formData.PreparerList.length > 1) {
      this.hiringService.onboardI9SupADelete(null, this.formData.PreparerList[index].seq).then((response: any) => {
        if (response.success) {
          this.removePreparerRow(index);
        } else {
        }
      });
    }
  }

  private removePreparerRow(index: any) {
    this.formData.PreparerList.splice(index, 1);
    if (this.formData.PreparerList.length == 0) {
      this.addPreparerRow();
    }
  }

  public clearSign2023(index: number) {
    this.signPreorTran2023.get(index).clear();
    this.formData.PreparerList[index].signPreorTranNotEmpty = false;
    this.formData.PreparerList[index].signPreorTranrawImgData = null;
    this.formData.PreparerList[index].signPreorTransubmitSignImg = null;
    this.formData.PreparerList[index].signPreorTrantypeSign = false;
    this.formData.PreparerList[index].signPreorTranshowClickMsg = false;
    this.formData.PreparerList[index].signPreorTranhideClick = false;
  }

  public clickSign2023(type: any, index: number) {
    const signaturePad = this.signPreorTran2023.get(index);
    if (signaturePad.isEmpty()) {
      this.formData.PreparerList[index].signPreorTrantypeSign = true;
      this.hiringService
        .getTypeSign(type, this.formData.PreparerList[index].PreparerFirstName + ' ' + this.formData.PreparerList[index].PreparerLastName)
        .then((response: any) => {
          if (response != null) {
            const base64Data = this.base64ArrayBuffer(response);
            const dataURL = 'data:image/png;base64,' + base64Data;
            signaturePad.fromDataURL(dataURL);
            this.formData.PreparerList[index].signPreorTranrawImgData = this.base64ArrayBuffer(response);
            this.formData.PreparerList[index].signPreorTransubmitSignImg = 'data:image/png;base64,' + this.base64ArrayBuffer(response);
            this.formData.PreparerList[index].signPreorTranNotEmpty = true;
            this.formData.PreparerList[index].signPreorTranhideClick = true;
          }
        });
      this.formData.PreparerList[index].signPreorTranshowClickMsg = false;
    } else {
      this.formData.PreparerList[index].signPreorTranshowClickMsg = true;
    }
  }
}
